// extracted by mini-css-extract-plugin
export default {"nextButton":"Qp0FAy"};